import React from 'react';
import OrganizationDashboardPage from '../../pages/OrganizationDashboardPage';
import ChooseLoginTypePage from '../../pages/ChooseLoginTypePage';
import ProductReleasePage from '../../pages/ProductReleasePage';
import { NativeBaseProvider } from "native-base";
import { ToastProvider } from 'react-native-toast-notifications'
import { NavigationContainer } from '@react-navigation/native';
import CustomNavigationBar from '../CustomNavigationBar'
import { nativeBaseTheme } from '../../theme'

import { createNativeStackNavigator } from '@react-navigation/native-stack';
import ResultsPage from 'src/pages/ResultsPage';

import { Platform } from 'react-native';

import ChangePasswordPage from '../../pages/ChangePasswordPage';
import SettingsPage from 'src/pages/SettingsPage';
import DesktopSettingsPage from 'src/pages/SettingsPage/DesktopSettingsPage';
import GrainProfileManagementPage from 'src/pages/GrainProfileManagementPage';
import UserGuidePage from 'src/pages/UserGuidePage';
import HelpPage from 'src/pages/HelpPage';
import { useSelector } from 'react-redux';

import { getPlatform } from 'src/utils/miscUtils';

const Stack = createNativeStackNavigator();

const linkingConfig = {
    prefixes: ['http://localhost:8080', 'https://grams-app.com'],
    config: {
        screens: {
            OrganizationDashboard: {
                path: '/',
                screens: {
                    Summary: 'summary',
                    Surveyors: 'surveyors',
                    History: 'history'
                }
            },
            Results: 'results/:jobId',
            ChooseLoginType: 'switch',
            ChangePassword: 'change-password',
            ProductRelease: 'product-release',
            Settings: 'settings',
            DesktopSettings: 'settings/desktop',
            GrainProfileManagement: 'settings/grain-profiles',
            UserGuide: 'user-guide',
            HelpPage: 'help-support',
        },
    },
}

const OrgSuperAdminStack = () => {

    const colorMode = useSelector((store) => store.settings.colorMode);
    const theme = nativeBaseTheme(colorMode);

    return <ToastProvider>
        <NativeBaseProvider theme={theme}>
            <React.Fragment>
                {
                    Platform.OS === "web" ? <style type="text/css">{`
                    @font-face {
                      font-family: 'MaterialCommunityIcons';
                      src: url(${require('react-native-vector-icons/Fonts/MaterialCommunityIcons.ttf')}) format('truetype');
                    }
                  `}</style> : null
                }
                <NavigationContainer linking={getPlatform() === "web" ? linkingConfig : null}>
                    <Stack.Navigator screenOptions={{
                        header: (props) => <CustomNavigationBar {...props} />,
                    }}>
                        <Stack.Screen name="ChooseLoginType" component={ChooseLoginTypePage} options={{ showTitle: true, title: 'Change Role', settings: false, previous: false }} />
                        <Stack.Screen name="OrganizationDashboard" component={OrganizationDashboardPage} options={{ showTitle: false, title: 'Jobs', settings: true, orgLogo: true, previous: false }} />
                        <Stack.Screen name="Results" component={ResultsPage} options={{ showTitle: true, title: 'Results', settings: false, previous: true }} />
                        <Stack.Screen name="ChangePassword" component={ChangePasswordPage} options={{ previous: true, showTitle: true, title: 'Change Password', settings: false }} />
                        {
                            getPlatform() === "web" ?
                                <Stack.Screen name="ProductRelease" component={ProductReleasePage} options={{ headerShown: false, title: "Product Releases", previous: true }} />
                                : null
                        }
                        <Stack.Screen name="Settings" component={SettingsPage} options={{ showTitle: true, headerShown: true, title: "Settings", previous: true }} />
                        <Stack.Screen name="DesktopSettings" component={DesktopSettingsPage} options={{ showTitle: true, headerShown: true, title: "Desktop Settings", previous: true }} />
                        <Stack.Screen name="GrainProfileManagement" component={GrainProfileManagementPage} options={{ showTitle: true, headerShown: true, title: "Grain Profiles", previous: true }} />
                        <Stack.Screen name="UserGuide" component={UserGuidePage} options={{ showTitle: true, headerShown: true, title: "User Guide", previous: true }} />
                        <Stack.Screen name="HelpPage" component={HelpPage} options={{ showTitle: true, headerShown: true, title: "Help & Support", previous: true }} />
                    </Stack.Navigator>
                </NavigationContainer>
            </React.Fragment>
        </NativeBaseProvider>
    </ToastProvider>
}

export {
    OrgSuperAdminStack
}
